import { styled } from "styletron-react"
import { colors, fonts } from "../../../Styles"
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";
import Overlay from "../overlay";

export default function SuccessAnimation({  }: {  }) {
  const successMessage = useSelector((state: RootState) => state.uiState.successMode.successMessage);

  return (
    <Overlay
      overrides={{
        color: colors.transparent,
        zIndex: 99999999999,
      }}
      content={
        <AnimationFrame>
          <div style={{ gridArea: "1/1/2/2", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <svg height={"25px"} width={"25px"} viewBox="0 0 284 284">
              <Checkmark d="M55.75,84.14C79.418,138.147 101.261,189.398 118.5,237.09C137.701,163.211 177.65,80.147 227.913,29" />
            </svg>
          </div>
          <Message>
            <p style={{ ...fonts.fontSize4, ...fonts.header, color: colors.greyLightTertiary }}>{successMessage}</p>
          </Message>
        </AnimationFrame>
      }
    /> 
  )
}

// #region | Animation Frame with border pop
const AnimationFrame = styled("div", {
  position: "absolute",
  bottom: "60px",
  left: "50%",
  transform: "translateX(-50%)",
  display: "grid",
  padding: "5px",
  gridTemplateColumns: "50px 1fr",
  gridTemplateRows: "50px",
  borderRadius: "10px",
  width: "0px",
  height: "50px",
  backgroundColor: colors.systemGreen,
  opacity: "0",
  animation: "frame 3s ease-out 1 forwards",
  "@keyframes frame": {
    "0%": { width: "0px", opacity: "0" },
    "20%": { width: "270px", opacity: "1" },
    "70%": { width: "270px", opacity: "1" },
    "100%": { width: "270px", opacity: "0" }
  },
  "::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "10px",
    border: `3px solid ${colors.systemGreen}`,
    opacity: 0,
    transform: "scale(1)",
    pointerEvents: "none",
    transformOrigin: "center",
    animation: "borderPop 3s ease-out 1 forwards",
  },
  "@keyframes borderPop": {
    "0%": { opacity: 0, transform: "scale(1)" },
    "20%": { opacity: 0, transform: "scale(1)" },
    "30%": { opacity: 0.6, transform: "scale(1.04, 1.2)" },
    "90%": { opacity: 0, transform: "scale(1.04, 1.2)" },
    "100%": { opacity: 0, transform: "scale(1.5, 2)" },
  }
});
// #endregion

// #region | Message Animation
const Message = styled("div", {
  gridArea: "1/1/2/3",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  animation: "message 3s ease-out 1 forwards",
  opacity: "0",
  "@keyframes message": {
    "0%": { opacity: "0" },
    "20%": { opacity: "0" },
    "25%": { opacity: "1" },
    "85%": { opacity: "1" },
    "100%": { opacity: "0" }
  },
})
// #endregion

// #region | Checkmark Animation
const Checkmark = styled("path", {
  fill: "none",
  stroke: colors.greyLightTertiary,
  strokeWidth: "25px",
  strokeLinecap: "round",
  strokeDasharray: "1000",
  strokeDashoffset: "1000",
  animation: "draw 3s cubic-bezier(.65,0,.35,1) 1 forwards",
  "@keyframes draw": {
    "0%": { strokeDashoffset: "1000" },
    "10%": { strokeDashoffset: "1000" },
    "20%": { strokeDashoffset: "600" },
    "50%": { strokeDashoffset: "0" },
    "100%": { strokeDashoffset: "0" },
  },
});
// #endregion